// Merged thumbnails module derived from src/shared/utils/utilities.jsx and
// src/alive-academics/utils/utilities.js. Asset import paths are relative to
// src/shared/utils/ (one level up into src/shared/assets/), unlike the source files
// which lived in src/shared/utils/ (../../shared/assets/...) or src/alive-academics/utils/
// (../../shared/assets/...).

// IMAGES: FILE ICONS
import pngThumb from '../assets/png-logo.svg'
import jpgThumb from '../assets/jpg-logo.svg'
import tiffThumb from '../assets/png-logo.svg'
import pdfThumb from '../assets/pdf-logo.svg'
import wordThumb from '../assets/word-logo.svg'
import excelThumb from '../assets/excel-logo.svg'
import fileThumb from '../assets/file-logo.svg'
import pptThumb from '../assets/ppt-logo.svg'
import videoThumb from '../assets/videofile-logo.svg'

// IMAGES: MEETING VIRTUAL BG IMAGES (only existed in alive-academics/utils/utilities.js)
import meetingBg1 from '../assets/meeting-vbgs/bg1.jpg'
import meetingBg2 from '../assets/meeting-vbgs/bg2.jpg'
import meetingBg3 from '../assets/meeting-vbgs/bg3.jpg'
import meetingBg4 from '../assets/meeting-vbgs/bg4.jpg'

// IMAGES: THUMBNAILS (only existed in alive-academics/utils/utilities.js)
import examDefault1 from '../assets/default-exam-thumb.jpg'
import examDefault2 from '../assets/default-exam-thumb.png'
import assignmentDefault1 from '../assets/assignment-default-thumb.jpg'
import assignmentDefault2 from '../assets/assignment-default-thumb2.jpg'
import discussionDefault1 from '../assets/discussion-default-thumb.jpg'
import discussionDefault2 from '../assets/discussion-default-thumb2.jpg'
import discussionDefault3 from '../assets/discussion-default-thumb3.jpg'
import studyMaterialDefault1 from '../assets/study-material-default-thumb.jpg'
import studyMaterialDefault2 from '../assets/study-material-default-thumb2.jpg'
import studyMaterialDefault3 from '../assets/study-material-default-thumb4.jpg'
import livesessionsDefault1 from '../assets/live-sessions-default-thumb.jpg'
import livesessionsDefault2 from '../assets/live-sessions-default-thumb2.jpg'
import livesessionsDefault3 from '../assets/live-sessions-default-thumb3.jpg'
import defaultOnlineCourseThumb1 from '../assets/default-thumb-1.svg'
import defaultOnlineCourseThumb2 from '../assets/default-thumb-2.svg'
import defaultOnlineCourseThumb3 from '../assets/default-thumb-3.svg'

export const attachmentThumbnails = {
    png: pngThumb,
    jpg: jpgThumb,
    jpeg: jpgThumb,
    tiff: tiffThumb,
    pdf: pdfThumb,
    docx: wordThumb,
    xls: excelThumb,
    xlsx: excelThumb,
    csv: excelThumb,
    default: fileThumb,
    pptx: pptThumb,
    mp4: videoThumb,
    wepm: videoThumb,
    ppsx: pptThumb,
}

// MEETINGS_VIRTUAL_BACKGROUNDS only existed in alive-academics/utils/utilities.js
export const MEETINGS_VIRTUAL_BACKGROUNDS = [
    { id: 1, src: meetingBg1, label: "Living Room" },
    { id: 2, src: meetingBg2, label: "Plane Wing" },
    { id: 3, src: meetingBg3, label: "Cafe" },
    { id: 4, src: meetingBg4, label: "Library" },
]

// defaultFeedThumbs only existed in alive-academics/utils/utilities.js.
// NOTE: appears to be an unused/leftover stub (all values are empty arrays) - preserved as-is.
export const defaultFeedThumbs = {
    exam: [],
    assignment: [],
    discussion: [],
    'study material': [],
}

// defaultOnlineCourseThumbs only existed in alive-academics/utils/utilities.js
export const defaultOnlineCourseThumbs = [defaultOnlineCourseThumb1, defaultOnlineCourseThumb2, defaultOnlineCourseThumb3]

// feedDefaultThumbs only existed in alive-academics/utils/utilities.js
export const feedDefaultThumbs = {
    exam: [examDefault1, examDefault2],
    quiz: [examDefault1, examDefault2],
    assignment: [assignmentDefault1, assignmentDefault2],
    discussion: [discussionDefault1, discussionDefault2, discussionDefault3],
    'study material': [studyMaterialDefault1, studyMaterialDefault2, studyMaterialDefault3],
    'live session': [livesessionsDefault1, livesessionsDefault2, livesessionsDefault3],
}
